import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { MessageModule } from 'primeng/message';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkspacePickerComponent } from './workspace-picker.component';
import { TreeModule } from 'primeng/tree';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';


@NgModule({
  declarations: [
    WorkspacePickerComponent
  ],
  imports: [
    CommonModule,
    TreeModule,
    ButtonModule,
    MessageModule,
    MenuModule,
    FormsModule,
    InputTextModule,
    IconFieldModule,
    InputIconModule

  ]
})
export class WorkspacePickerModule { }
